export const ROUTES = {
  ROOT: '/',
  HOME: '/',
  DETAILS: '/details'
};
